import DiscountInfoBlock, {
  DiscountInfoBlockProps
} from '@anm/components/subscription/DiscountInfoBlock';
import isUndefined from 'lodash/fp/isUndefined';
import { FC } from 'react';

import Wrapper, {
  CrossedPrice,
  LoaderWrapper,
  PredictPriceContent,
  TotalAmount,
  TotalPriceWrapper,
  TotalTitle
} from './Wrapper';

export type PredictPriceProps = DiscountInfoBlockProps & {
  isPending: boolean;
  fullPlanPrice: number;
  totalPrice?: number;
};

type TotalPriceProps = {
  endPrice: number;
  planPrice?: number;
};

export const TotalPrice: FC<TotalPriceProps> = ({ endPrice, planPrice }) => (
  <TotalPriceWrapper>
    <TotalTitle>Your total</TotalTitle>

    <TotalAmount>
      {planPrice && planPrice !== endPrice && (
        <CrossedPrice>${planPrice}</CrossedPrice>
      )}
      <span>${endPrice}</span>
    </TotalAmount>
  </TotalPriceWrapper>
);

const PredictPrice: FC<PredictPriceProps> = ({
  credit,
  planName,
  isPending,
  planPrice,
  totalPrice,
  periodName,
  fullPlanPrice,
  annualDiscount,
  amountDiscount,
  percentsDiscount
}) => (
  <Wrapper>
    {isPending && <LoaderWrapper size="large" color="blue" />}
    <PredictPriceContent isPending={isPending}>
      {credit && (
        <DiscountInfoBlock
          {...{
            credit,
            planName,
            periodName,
            annualDiscount,
            amountDiscount,
            percentsDiscount
          }}
          planPrice={fullPlanPrice}
        />
      )}
      {!isUndefined(totalPrice) && (
        <TotalPrice endPrice={totalPrice} planPrice={planPrice} />
      )}
    </PredictPriceContent>
  </Wrapper>
);

export default PredictPrice;
